// One `Intl` instance per language and options, created on first use: constructing them is slow,
// and a module-level constant would freeze the language the module was loaded in.
const cache = new Map();
function cached(kind, language, options, create) {
    const key = `${kind}|${language}|${JSON.stringify(options ?? {})}`;
    let instance = cache.get(key);
    if (!instance) {
        instance = create();
        cache.set(key, instance);
    }
    return instance;
}
export function dateFormat(language, options = { dateStyle: "medium" }) {
    return cached("date", language, options, () => new Intl.DateTimeFormat(language, options));
}
export function dateTimeFormat(language, options = { dateStyle: "medium", timeStyle: "short" }) {
    return cached("date", language, options, () => new Intl.DateTimeFormat(language, options));
}
export function relativeTimeFormat(language, options = { numeric: "auto" }) {
    return cached("relative", language, options, () => new Intl.RelativeTimeFormat(language, options));
}
export function numberFormat(language, options) {
    return cached("number", language, options, () => new Intl.NumberFormat(language, options));
}
export function currencyFormat(language, currency, options) {
    const all = { ...options, style: "currency", currency };
    return cached("number", language, all, () => new Intl.NumberFormat(language, all));
}
export function listFormat(language, options = { type: "conjunction" }) {
    return cached("list", language, options, () => new Intl.ListFormat(language, options));
}
export function collator(language, options) {
    return cached("collator", language, options, () => new Intl.Collator(language, options));
}
//# sourceMappingURL=format.js.map